export const SIDEBAR_DATA = 'SIDEBAR_DATA ';

export const getSidebarData = (data) => {
	return {
		type: SIDEBAR_DATA ,
		sidebarData: data
	}
};
